import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {fieldObjectSectionStyle} from "../../../helpers/graphQLShortcuts";
import {fieldObjectSectionStyleCss} from "../../../helpers/createStyles";
import Paragraph from "../../Paragraph";
import AngleDivider from "../../AngleDivider/AngleDivider";
import {filterHeadline} from "../../../helpers/filters";
import './AngledHero.scss';

interface Data {
    paragraphById: {
        fieldTxtHeadline: string;
        fieldTxtSubTitle: string;
        fieldVarTopAngleColor: string;
        fieldVarBottomAngleColor: string;
        fieldAngledHeroCta: Array<{
            targetRevisionId: string;
        }>;
        fieldAngledHeroItemStyle: Array<{entity: Array}>;
    }
}

class AngledHeroQuery extends Query<Data, {id: string}> {}

const GET_COMPONENT = gql`
    query paragraphById($id: String!) {
        paragraphById:paragraphRevisionById(id: $id) {
            ... on Paragraph {
                ... on Paragraph {
                    ... on ParagraphComponentAngledHero {
                        fieldTxtHeadline
                        fieldTxtSubTitle
                        fieldVarTopAngleColor
                        fieldVarBottomAngleColor
                        fieldAngledHeroCta {
                            targetRevisionId
                        }
                        fieldAngledHeroItemStyle {
                                ${fieldObjectSectionStyle}
                        }
                    }
                }
            }
        }
    }
`;

const AngledHero = ({id, componentIndex, markComponentLoadedAs, handleLoadedComponents}) => (
    <AngledHeroQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;
            const styles = fieldObjectSectionStyleCss(field.fieldAngledHeroItemStyle);
            const isFirstComponent = componentIndex === 0;

            markComponentLoadedAs(id, true);

            return (
                <React.Fragment>
                    <div className={`angledHero${styles.classNames}`} id={styles.id} style={styles.css}>
                        {styles.childBackground.isActive && (
                            <div style={styles.childBackground.css}/>
                        )}
                        {field.fieldVarTopAngleColor !== 'none' && (
                            <AngleDivider topColor="transparent" bottomColor={field.fieldVarTopAngleColor} inverted />
                        )}
                        <div className="container">
                            {field.fieldTxtHeadline && isFirstComponent && (
                                // eslint-disable-next-line react/no-danger
                                <h1 className="angledHero__title" dangerouslySetInnerHTML={{__html: filterHeadline(field.fieldTxtHeadline)}} />
                            )}
                            {field.fieldTxtHeadline && !isFirstComponent && (
                                // eslint-disable-next-line react/no-danger
                                <h2 className="angledHero__title" dangerouslySetInnerHTML={{__html: filterHeadline(field.fieldTxtHeadline)}} />
                            )}
                            {field.fieldTxtSubTitle && isFirstComponent && (
                                // eslint-disable-next-line react/no-danger
                                <h2 className="angledHero__subTitle" style={{fontSize: '18px'}} dangerouslySetInnerHTML={{__html: filterHeadline(field.fieldTxtSubTitle)}} />
                            )}
                            {field.fieldTxtSubTitle && !isFirstComponent && (
                                // eslint-disable-next-line react/no-danger
                                <h3 className="angledHero__subTitle" dangerouslySetInnerHTML={{__html: filterHeadline(field.fieldTxtSubTitle)}} />
                            )}
                            {field.fieldAngledHeroCta && field.fieldAngledHeroCta.targetRevisionId && (
                                <Paragraph key={`${id}_${field.fieldAngledHeroCta.targetRevisionId}`}
                                           id={String(field.fieldAngledHeroCta.targetRevisionId)}
                                           handleLoadedComponents={handleLoadedComponents}/>
                            )}
                        </div>
                        {field.fieldVarBottomAngleColor !== 'none' && (
                            <AngleDivider topColor="transparent" bottomColor={field.fieldVarBottomAngleColor}/>
                        )}
                    </div>
                </React.Fragment>
            );
        }}
    </AngledHeroQuery>
);

AngledHero.propTypes = {
    id: PropTypes.number.isRequired,
    componentIndex: PropTypes.number,
    markComponentLoadedAs: PropTypes.func.isRequired,
    handleLoadedComponents: PropTypes.func.isRequired
};

AngledHero.defaultProps = {
    componentIndex: null
};

export default AngledHero;



// WEBPACK FOOTER //
// ./frontend/components/Hero/AngledHero/AngledHero.jsx